<!-- 红包维护 -->
<template>
    <span style="color: aliceblue">注意所有的结构默认是折叠起来的,红包默认展示有效期以内的</span>
    <div>
        <div class="header-box">
            <div class="left-box">
                <el-upload
                    class="avatar-uploader"
                    action="/api/zztCouponTable/uploadTheZztCouponData"
                    :show-file-list="false"
                    :headers="{ satoken: token }"
                    :on-success="errorHandle">
                    <el-button>excel批量导入</el-button>
                </el-upload>
                <el-button @click="downloadRuleExcel">下载模版</el-button>
            </div>
        </div>
        <div class="date-picker">
            <div>
                <el-date-picker
                    v-model="search.time"
                    type="datetimerange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    range-separator="至"
                    start-placeholder="Start date"
                    end-placeholder="End date" />
            </div>
            <div class="right-box">
                <el-checkbox-group v-model="search.queryType">
                    <el-checkbox label="仅看有效期内红包" value="all" />
                </el-checkbox-group>
                <el-button @click="searchByTime">查询</el-button>
                <el-button type="primary" @click="addDialogVisible = true">新增红包</el-button>
            </div>
        </div>
        <div class="info-box">
            <el-table v-loading="loading" height="100%" :data="tableData" style="width: 100%; margin-bottom: 20px" row-key="id" border default-expand-all>
                <el-table-column prop="label" width="400" label="开始时间" />
                <el-table-column prop="startPrice" label="开始价位（含）：元" />
                <el-table-column prop="endPrice" label="结束价位（含）：元" />
                <el-table-column prop="burdenFee" label="红包：元" />
                <el-table-column label="操作">
                    <template #default="scope">
                        <el-button v-if="scope.row.id == null" size="small" @click="handleEdit(scope.row)"> 编辑 </el-button>
                        <el-button v-if="scope.row.id == null" size="small" type="danger" @click="handleDelete(scope.row.volId)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <div class="dialog-box">
        <el-dialog class="update-dialog" v-model="editDialogVisible" title="编辑" width="500">
            <el-form :model="updateForm">
                <el-form-item label="名称">
                    <el-input v-model="updateForm.category" autocomplete="off" />
                </el-form-item>
                <el-form-item label="使用金额">
                    <el-input-number v-model="updateForm.priceGradient"></el-input-number>
                </el-form-item>
                <el-form-item label="抵用金额">
                    <el-input-number v-model="updateForm.burdenFee"></el-input-number>
                </el-form-item>
                <el-form-item label="开始日期">
                    <el-date-picker type="datetime" value-format="YYYY-MM-DD HH:mm:ss" v-model="updateForm.startTime" />
                </el-form-item>
                <el-form-item label="截止日期">
                    <el-date-picker type="datetime" value-format="YYYY-MM-DD HH:mm:ss" v-model="updateForm.endTime" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="update"> 确认 </el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog class="add-dialog" v-model="addDialogVisible" title="编辑" width="1000">
            <div class="input-box">
                <el-form :model="addForm">
                    <el-form-item label="名称">
                        <el-input v-model="addForm.category" autocomplete="off" />
                    </el-form-item>
                    <el-form-item label="使用金额">
                        <el-input-number v-model="addForm.priceGradient"></el-input-number>
                    </el-form-item>
                    <el-form-item label="抵用金额">
                        <el-input-number v-model="addForm.burdenFee"></el-input-number>
                    </el-form-item>
                    <el-form-item label="开始日期">
                        <el-date-picker type="datetime" value-format="YYYY-MM-DD HH:mm:ss" v-model="addForm.startTime" />
                    </el-form-item>
                    <el-form-item label="截止日期">
                        <el-date-picker type="datetime" value-format="YYYY-MM-DD HH:mm:ss" v-model="addForm.endTime" />
                    </el-form-item>
                </el-form>
                <el-button type="primary" @click="addVol">添加红包</el-button>
            </div>
            <div class="vol-info-box">
                <el-table :data="addTableData">
                    <el-table-column label="名称" prop="category" />
                    <el-table-column label="使用金额" prop="priceGradient" />
                    <el-table-column label="抵用金额" prop="burdenFee" />
                    <el-table-column label="开始日期" prop="startTime" />
                    <el-table-column label="截止日期" prop="endTime" />
                    <el-table-column label="操作">
                        <template #default="scope">
                            <el-button type="danger" @click="deleteVol(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="add"> 确认 </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
    <div>
        <FixedButtons />
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import axios from "axios";

    export default {
        name: "redpacketView",
        components: { FixedButtons },
        data() {
            return {
                token: localStorage.getItem("sa"),
                fileList: [],
                loading: true,
                updateForm: {
                    burdenFee: 0,
                    category: "",
                    endTime: "",
                    id: 0,
                    priceGradient: 0,
                    startTime: "",
                },
                addForm: {},
                addTableData: [],
                search: {
                    category: "",
                    priceGradient: "",
                    burdenFee: "",
                    time: [],
                    queryType: [],
                    pageSize: 20,
                },
                tableData: [],
                selectedValue: true,
                justCanUseCheckbox: [],
                pageSize: 20,
                currentPage: 1,
                totalPages: 1,
                total: 1,
                editDialogVisible: false,
                addDialogVisible: false,
            };
        },
        created() {},

        methods: {
            beforeUpload() {
                let file = this.fileList[0].raw;
                const isExcel = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || this.fileList[0].raw.type === "application/vnd.ms-excel";
                if (!isExcel) {
                    this.$message.error("上传文件只能是 xls 或 xlsx 格式!");
                    return false;
                }

                return true;
            },
            errorHandle(res) {
                if (res.code !== 200) {
                    this.$message.error(res.message);
                } else {
                    this.$message.success(res.message);
                }
            },
            deleteVol(item) {
                //  从this.addTableData中删除item
                this.addTableData.splice(this.addTableData.indexOf(item), 1);
            },
            addVol() {
                let vol = JSON.parse(JSON.stringify(this.addForm));
                //  判断是否有相同红包规则
                if (!this.addTableData.indexOf(vol)) {
                    this.$message.error("已有相同红包规则");
                    return;
                }
                this.addTableData.push(vol);
            },
            add() {
                axios
                    .post("/api/zztCouponTable/addBatch", this.addTableData, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        if (res.data.code === 200) {
                            this.$message.success("添加红包成功");
                            this.addTableData = [];
                            this.addForm = {};
                            //  刷新页面
                            this.searchByTime();
                        } else {
                            this.$message.error("添加红包失败");
                        }
                    });
            },
            update() {
                this.editDialogVisible = false;
                axios
                    .put("/api/zztCouponTable/updateById", this.updateForm, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        if (res.data.code === 200) {
                            this.$message.success("修改成功");
                            //  刷新页面
                            this.searchByTime();
                        } else {
                            this.$message.error("修改失败");
                        }
                    });
            },
            downloadRuleExcel() {
                const _this = this;
                axios
                    .get("/api/zztCouponTable/downloadingTheZztCouponTableTemplate", {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        if (res.data.code === 200) {
                            //  跳转 http://47.109.68.137:39000/template/zztCouponTableTemplate/1730084070633_1_红包规则模板.xls
                            window.location.href = res.data.data;
                        } else {
                            _this.$message.error("获取下载链接失败");
                        }
                    });
            },
            handleDelete(item) {
                this.$confirm("此操作将永久删除该红包，是否继续?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        axios
                            .delete("/api/zztCouponTable/delete?idList=" + item, {
                                headers: {
                                    satoken: localStorage.getItem("sa"),
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message.success("删除成功");
                                    this.searchByTime();
                                } else {
                                    this.$message.error("删除失败");
                                }
                            });
                    })
                    .catch(() => {
                        this.$message.warning("取消删除");
                    });
            },
            handleEdit(item) {
                this.editDialogVisible = true;
                this.updateForm = {
                    id: item.volId,
                    burdenFee: item.burdenFee,
                    category: item.category,
                    startTime: item.startTime,
                    endTime: item.endTime,
                    priceGradient: item.endPrice,
                };
            },
            searchByTime() {
                const _this = this;
                _this.loading = true;
                //  判断search.time是否为空
                if (this.search.time == null || this.search.time.length === 0) {
                    //  时间为空，则默认查询所有优惠卷，日期从1949开始,
                    this.search.time = [];
                    this.search.time[0] = "2000-10-01 00:00:00";
                    this.search.time[1] = "2100-10-01 00:00:00";
                }
                let url = `/api/zztCouponTable/queryZztCouponTable?startTime=${this.search.time[0]}&endTime=${this.search.time[1]}`;
                if (this.search.queryType.length === 0) {
                    url += `&queryType=${this.search.queryType[0]}`;
                }
                axios
                    .get(url, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        if (res.data.code === 200) {
                            //  将结果按照时间排序
                            if (res.data.data.length === 0) {
                                this.$message.info("暂无红包数据");
                                this.loading = false;
                                return;
                            }
                            res.data.data.sort((a, b) => {
                                const dateA = new Date(a.startTime);
                                const dateB = new Date(b.startTime);
                                return dateA - dateB; // 升序排序
                                // 如果需要降序排序，则返回 dateB - dateA
                            });
                            let data = this.buildTree(res.data.data);
                            _this.tableData = data;
                        }
                        _this.loading = false;
                    });
            },
            buildTree(dataArr) {
                // 创建一个空对象来存储处理后的数据
                const processedData = {};
                let treeA = 1;
                let treeB = 10000;
                // 遍历原始数据
                for (let i = 0; i < dataArr.length; i++) {
                    let item = dataArr[i];
                    let startPrice = 0;
                    if (i >= 1 && item.category === dataArr[i - 1].category && item.startTime === dataArr[i - 1].startTime) {
                        startPrice = dataArr[i - 1].priceGradient;
                    }
                    // 如果没有这个 startTime 的键，则创建一个空数组
                    let startTime = item.startTime.substring(0, item.startTime.indexOf(" "));
                    if (!processedData[startTime]) {
                        processedData[startTime] = {
                            id: treeA++,
                            label: startTime, // 用于显示的标签
                            children: [], // 用于存储子节点的数组
                        };
                    }
                    // 检查是否已经存在这个 category 的子节点
                    let categoryExists = false;
                    processedData[startTime].children.forEach((child) => {
                        if (child.label === item.category) {
                            child.children.push({
                                volId: item.id,
                                label: item.endTime,
                                category: item.category,
                                startTime: item.startTime,
                                endTime: item.endTime,
                                endPrice: item.priceGradient,
                                startPrice: startPrice,
                                burdenFee: item.burdenFee,
                            });
                            categoryExists = true;
                        }
                    });

                    // 如果不存在，则创建一个新的 category 子节点
                    if (!categoryExists) {
                        processedData[startTime].children.push({
                            id: treeB--,
                            label: item.category,
                            children: [
                                {
                                    volId: item.id,
                                    startTime: item.startTime,
                                    category: item.category,
                                    endTime: item.endTime,
                                    label: item.endTime,
                                    startPrice: startPrice,
                                    endPrice: item.priceGradient,
                                    burdenFee: item.burdenFee,
                                },
                            ],
                        });
                    }
                }

                // 将对象的键值对转换为数组，以便 el-table 可以直接使用
                const treeData = Object.values(processedData);
                return treeData;
            },
        },
        mounted() {
            this.searchByTime();
        },
        watch: {},
        computed: {},
    };
</script>

<style>
    .left-box {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    .left-box > * {
        margin-right: 10px;
    }

    .info-box {
        background-color: white;
        flex: 7;
        width: 100%;
        overflow-y: hidden;
    }

    .info-table {
        width: 100%;
        border-collapse: collapse;
        background-color: white;
    }

    .info-table thead {
        background-color: #f2f2fe;
    }

    .info-table tr {
        height: 40px;
    }

    .info-table td,
    .info-table th {
        border: 1px solid black;
        text-align: center;
    }

    .header-box {
        display: flex;
        flex: 1;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        height: 50px;
    }

    .header-box .left-box {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .header-box .left-box .upload-demo {
        display: flex;
        align-items: center;
        margin-right: 10px;
    }

    .date-picker .right-box {
        display: flex;
    }

    .page-box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        flex: 1;
    }

    .date-picker {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .update-dialog .el-form-item,
    .add-dialog .el-form-item {
        display: flex;
    }

    .update-dialog .el-form-item__label {
        flex: 1;
        width: 80px;
    }

    .add-dialog .el-form-item__label {
        flex: 1;
    }

    .add-dialog .el-form-item__content {
        flex: 9;
    }

    .add-dialog .el-input {
        width: 300px !important;
    }

    .update-dialog .el-form-item__content {
        flex: 4;
    }

    .update-dialog .el-input,
    .update-dialog .el-input-number {
        flex: 4;
    }
</style>
